/* globals */
import { CARD_TYPE_POSTER, spaceToDash } from 'helpers/ContentHelper';

const getSelectedFilters = previousItemsRef => previousItemsRef?.browseFilters;

const isPropValuesEqual = (subject, target, propNames) =>
  propNames.every(propName => subject[propName] === target[propName]);

const getUniqueItemsById = items => {
  const propNamesArray = ['id'];

  return items.filter(
    (item, index, array) =>
      index === array.findIndex(foundItem => isPropValuesEqual(foundItem, item, propNamesArray)),
  );
};

const reduceBrowseResults = ({ filters = [] }) => {
  const createHeadline = headline => `${headline?.toLowerCase()}`;
  const browseFilters =
    filters?.reduce((acc, filter) => {
      const headline = createHeadline(filter?.headline);
      return {
        ...acc,
        [headline]: {
          items: filter?.items?.member ?? [],
          next: filter?.items?.view?.next ?? null,
          type: CARD_TYPE_POSTER,
        },
      };
    }, {}) ?? {};

  return browseFilters;
};

const getFilterName = ({ pathName }) => {
  const decodePath = decodeURI(pathName);
  return spaceToDash(decodePath)
    .replace(`/browse/`, '')
    .replace(/\/+$/, '');
};

const getFilterDisplayName = filterName => filterName?.trim()?.toLowerCase();

export {
  getSelectedFilters,
  reduceBrowseResults,
  getFilterName,
  getFilterDisplayName,
  getUniqueItemsById,
};
